"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useClientEventListener;

var _useEventListener = _interopRequireDefault(require("@sprinx/react-hooks/useEventListener"));

var _useClient = _interopRequireDefault(require("../useClient"));

function useClientEventListener(eventName, handler, clientCode) {
  var client = (0, _useClient.default)(clientCode);
  (0, _useEventListener.default)(eventName, handler, client);
}